import { render, staticRenderFns } from "./Multiple.vue?vue&type=template&id=493e4d10&scoped=true"
import script from "./Multiple.vue?vue&type=script&lang=js"
export * from "./Multiple.vue?vue&type=script&lang=js"
import style0 from "./Multiple.vue?vue&type=style&index=0&id=493e4d10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493e4d10",
  null
  
)

export default component.exports